import type { IconSvgObject } from './types';

const EnteringGeoFenceIcon: IconSvgObject = [
  ["path", { d: "M12 17L15.5 13.5M12 17L8.5 13.5M12 17V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 15C3.7492 15.6327 3 16.4384 3 17.3158C3 19.3505 7.02944 21 12 21C16.9706 21 21 19.3505 21 17.3158C21 16.4384 20.2508 15.6327 19 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EnteringGeoFenceIcon;
